export const SaveBadge = ({ testid = "bundle-save-badge", className = "" }) => (
  <span data-testid={testid}
    className={`inline-flex items-center rounded-full bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border border-emerald-500/30 px-2 py-0.5 text-[0.7rem] font-bold uppercase tracking-wide ${className}`}>
    Save $1.90
  </span>
);
